import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { ReviewDisplay } from '@grandvisionhq/reviews';
import { useFeatureToggles } from '@grandvisionhq/state';
import { getAttrValue } from '@grandvisionhq/utils';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';

const UserReviewsDisplay = ({ isSingleColumn  })=>{
    const { isReviewsEnabled  } = useFeatureToggles();
    const { productType , product , activeVariant: { sku  } ,  } = useProductDetailContext();
    if (!isReviewsEnabled) {
        return null;
    }
    const isLenses = CommerceToolsApi.isLenses(productType);
    var ref;
    const brandKey = String(getAttrValue((ref = product === null || product === void 0 ? void 0 : product.masterVariant) !== null && ref !== void 0 ? ref : {}, 'brandKey'));
    const reviewsInitialId = isLenses ? brandKey : product === null || product === void 0 ? void 0 : product.masterVariant.sku;
    const reviewsInitialSku = isLenses ? undefined : sku // SKU is not required for CL
    ;
    return /*#__PURE__*/ React.createElement(ReviewDisplay, {
        productId: reviewsInitialId,
        variantId: reviewsInitialSku,
        isSingleColumn: isSingleColumn
    });
};

export { UserReviewsDisplay };
//# sourceMappingURL=UserReviewsDisplay.js.map
